<script setup></script>

<template>
	<div class="sw-buttons">
		<button class="sw-prev">
			<svg class="mr-1 size-6" fill="none" stroke="currentColor" stroke-width="1.5" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
				<path d="M15.75 19.5 8.25 12l7.5-7.5" stroke-linecap="round" stroke-linejoin="round" />
			</svg>
		</button>
		<button class="sw-next">
			<svg class="ml-1 size-6" fill="none" stroke="currentColor" stroke-width="1.5" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
				<path d="m8.25 4.5 7.5 7.5-7.5 7.5" stroke-linecap="round" stroke-linejoin="round" />
			</svg>
		</button>
	</div>
</template>

<style lang="scss" scoped>
.sw-buttons {
	@apply pointer-events-none absolute left-0 top-1/2 z-40 flex w-full -translate-y-1/2 items-center justify-between px-3 transition-all duration-300 ease-in-out;
	button {
		@apply pointer-events-auto invisible flex aspect-square w-10 items-center justify-center rounded-full bg-black/50 opacity-0 transition-all duration-300 ease-in-out md:w-14;
		svg {
			@apply stroke-white;
		}

		&.swiper-button-disabled {
			@apply invisible opacity-0;
		}

		&:hover {
			@apply bg-black/80;
		}
	}
}
</style>
